import { Link } from "react-router-dom";
import { statusObject } from "../utils/allProductStatus";
import { cashnator, cashnatorFloat, phoneMask } from "../utils/functions";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType } from "../utils/gradingTypes";
import { getGradingValue } from "./productValues";
import { isExtendedArt, KIND_LABELS, orderPath } from "../extendedArt/kind";

export const DELIVERY_LABELS = { presencial: "Presencial", correios: "Correio" };
const YES_NO = { true: "Sim", false: "Não" };
const onlyDigits = (value) => String(value ?? "").replace(/\D/g, "");
const PAYMENT_LABELS = { PIX: "PIX", CREDIT_CARD: "Cartão de Crédito" };

export const PRODUCT_BASE_COLUMNS = [
    { key: "_id", header: "ID", visible: false, persist: false, hideable: false, filter: "ids", exportable: false },
    { key: "user.name", header: "Nome", width: 180, filter: "list" },
    { key: "user.email", header: "E-mail", width: 200, visible: false, filter: "text" },
    {
        key: "user.phone", header: "Telefone", width: 140, visible: false, filter: "digits",
        accessor: (row) => onlyDigits(row.user?.phone), format: (value) => phoneMask(value),
    },
    {
        // Linha de arte estendida não tem gradingType: o "Tipo" vira o selo do produto (spec §5.1).
        key: "gradingType", header: "Tipo", width: 120, filter: "list",
        accessor: (row) => (isExtendedArt(row) ? KIND_LABELS.extended_art : getGradingTypeLabel(row.gradingType)),
        cell: ({ value, row }) => (isExtendedArt(row)
            ? <span className="rounded bg-purple-700 px-2 py-0.5 text-xs text-white">{KIND_LABELS.extended_art}</span>
            : value),
    },
    { key: "autographEvaluation", header: "Autógrafo", width: 110, filter: "list", accessor: (row) => Boolean(row.autographEvaluation), labels: YES_NO },
    {
        key: "preLacreFormat", header: "Pré lacre", width: 150, visible: false, filter: "list",
        accessor: (row) => (normalizeGradingType(row.gradingType) === "pre" && row.preLacreFormat ? getPreLacreFormatLabel(row.preLacreFormat) : "-"),
    },
    { key: "numberOfCards", header: "Nº de itens", width: 100, filter: "list" },
    { key: "delivery", header: "Entrega", width: 110, filter: "list", labels: DELIVERY_LABELS },
    { key: "finalPrice", header: "Valor final", width: 110, format: (value) => cashnator(value) },
    { key: "cardsValue", header: "Valor declarado", width: 130, visible: false, format: (value) => cashnator(value) },
    { key: "insurance", header: "Taxa de manuseio", width: 130, visible: false, format: (value) => cashnator(value) },
    { key: "shipping", header: "Frete pago", width: 120, visible: false, format: (value) => cashnatorFloat(value) },
    { key: "gradingValue", header: "Valor graduação", width: 130, visible: false, accessor: (row) => getGradingValue(row), format: (value) => cashnator(value) },
    { key: "createdAt", header: "Criado", width: 110, type: "date", filter: "date" },
    { key: "updatedAt", header: "Atualizado", width: 110, type: "date", filter: "date", visible: false },
    { key: "receivedAt", header: "Recebido", width: 110, type: "date", filter: "date" },
    { key: "paidAt", header: "Pago", width: 110, type: "date", filter: "date", visible: false },
    { key: "calculatedDeadline", header: "Prazo", width: 110, type: "date", filter: "date" },
    { key: "status", header: "Status", width: 180, filter: "list", labels: statusObject },
    { key: "trackingCode", header: "Rastreio", width: 140, filter: "text" },
    { key: "coupon.code", header: "Cupom", width: 110, visible: false, filter: "list" },
    { key: "postalCode", header: "CEP", width: 110, visible: false, filter: "text" },
    { key: "city", header: "Cidade", width: 130, visible: false, filter: "list" },
    { key: "state", header: "Estado", width: 90, visible: false, filter: "list" },
    { key: "store.name", header: "Loja", width: 140, visible: false, filter: "list" },
    {
        key: "gradedAt", header: "Em Processo de Lacre", width: 120, filter: "list",
        accessor: (row) => Boolean(row.gradedAt), labels: YES_NO,
        format: (value) => (value ? "✔" : "X"),
        cellClassName: (row) => (row.gradedAt ? "text-green-500" : "text-red-500"),
    },
    { key: "createdByAdmin", header: "Criado por Admin?", width: 120, visible: false, filter: "list", labels: YES_NO },
    { key: "paymentMethod", header: "Forma de Pagamento", width: 150, visible: false, filter: "list", labels: PAYMENT_LABELS },
    {
        key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
        cell: ({ row }) => <Link to={orderPath(row)} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</Link>,
    },
];

export const buildSelectionColumn = ({ isSelected, onToggle }) => ({
    key: "select", header: "", width: 48, persist: false, hideable: false, sortable: false, resizable: false, exportable: false,
    cell: ({ row }) => (
        <input type="checkbox" readOnly checked={isSelected(row._id)} onClick={(event) => onToggle(event, row._id)} aria-label="Selecionar pedido" />
    ),
});
